import React from 'react';
import { Filter, Brush, EyeOff, CheckCheck, RefreshCw, Info, Settings, HelpCircle } from 'lucide-react';
import { Translations } from '../i18n/translations';

interface ControlBarLegendProps {
  t: Translations;
}

export const ControlBarLegend: React.FC<ControlBarLegendProps> = ({ t }) => {
  return (
    <div className="bg-white dark:bg-gray-800 border-2 border-gray-300 dark:border-gray-600 p-3 sm:p-4">
      <h3 className="font-bold mb-3 flex items-center gap-2 text-gray-900 dark:text-white">
        <HelpCircle className="w-4 h-4" />
        {t.settingsLegend}
      </h3>
      <table className="text-xs sm:text-sm text-gray-700 dark:text-gray-300">
        <tbody>
          <tr>
            <td className="pr-2 py-1 align-top"><Filter className="w-4 h-4" aria-hidden="true" /></td>
            <td className="py-1"><strong>{t.flagClickbait}:</strong> {t.legendFlagClickbait}</td>
          </tr>
          <tr>
            <td className="pr-2 py-1 align-top"><Brush className="w-4 h-4" aria-hidden="true" /></td>
            <td className="py-1"><strong>{t.clean}:</strong> {t.legendClean}</td>
          </tr>
          <tr>
            <td className="pr-2 py-1 align-top"><EyeOff className="w-4 h-4" aria-hidden="true" /></td>
            <td className="py-1"><strong>{t.hideClickbait}:</strong> {t.legendHideClickbait}</td>
          </tr>
          <tr>
            <td className="pr-2 py-1 align-top"><CheckCheck className="w-4 h-4" aria-hidden="true" /></td>
            <td className="py-1"><strong>{t.markAllAsRead}:</strong> {t.legendMarkAllAsRead}</td>
          </tr>
          <tr>
            <td className="pr-2 py-1 align-top"><RefreshCw className="w-4 h-4" aria-hidden="true" /></td>
            <td className="py-1"><strong>{t.refreshAll}:</strong> {t.legendRefresh}</td>
          </tr>
          <tr>
            <td className="pr-2 py-1 align-top"><Info className="w-4 h-4" aria-hidden="true" /></td>
            <td className="py-1"><strong>{t.about}:</strong> {t.legendAbout}</td>
          </tr>
          <tr>
            <td className="pr-2 py-1 align-top"><Settings className="w-4 h-4" aria-hidden="true" /></td>
            <td className="py-1"><strong>{t.settings}:</strong> {t.legendSettings}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
